import { useEffect } from 'react';

import HeaderOnlyWhite from '../components/HeaderOnlyWhite'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import '../Assets/css/swiper.min.css'
import '../Assets/css/hoteldetails.css'
import '../Assets/css/referralmenu.css'
import '../Assets/css/paymentform.css'

// import  '../Assets/js/datetimefunc.js'
import  '../Assets/js/referralmenu.js'

function Referral() {

  useEffect(() =>
  {
    window.CallDefaultFunction("ReferralMenu");
  }, []);

  return (
    <>
      <div className="basic">

        <HeaderOnlyWhite />

        <div className="MainContentSection">
          <div className="MainSectionWithoutAnyAdd IgnoreWPercent" style={{maxWidth:"none"}}>
            <div className="ReferralSwiperSlideMainContainer">
              <div className="ReferralSwiperSlideAllContentWrapper">
                <div className="loading_grey ImageFullCover RoomPanelImageBackgroundDisplay" id="LoadingImageBackground" />
                <img src="/Assets/images/ReferralHeaderImages/1.jpg" className="ImageFullCover ContainerWithMaskEdge" id="RefSwiperBackground" style={{opacity:0}} />
                <div className="ReferralSwiperSlideContainer swiper-initialized swiper-horizontal swiper-backface-hidden">
                  <div className="swiper-wrapper" id="ReferralSwiperSlideWrapper">
                    <div className="ReferralSwiperSlide swiper-slide swiper-slide-next swiper-slide-prev">
                      <div className="image-wrapperRefMenu">
                        <div className="loading-blockerRefMenu loading_grey" />
                        <img src="/Assets/images/ReferralHeaderImages/1.jpg"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="PopularAreasLeftRightButtonContainer PaddingButtonLeft" style={{zIndex:"1"}}>
                  <button className="NextPreviousSwiperButton Selectable2 PopularAreaButtonLeft">
                    <img src="/Assets/images/ButtonIcon/chevron.svg" />
                  </button>
                </div>
                <div className="PopularAreasLeftRightButtonContainer PaddingButtonRight" style={{zIndex:"1"}}>
                  <button className="NextPreviousSwiperButton Selectable2 PopularAreaButtonRight">
                    <img src="/Assets/images/ButtonIcon/chevron.svg" />
                  </button>
                </div>
                <div className="swiper-pagination PointExchangePagination" />
              </div>
            </div>
          </div>
          <div className="ReferralContentWrapper">
            <div className="ReferralLeftWrapper">
              <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius OriginalPriceToHideOnOff" style={{backgroundColor:"#F1F7FB"}}>
                <div className="LeftSectionAllPoinInfoWrapper MarginRefLeft">
                  <div className="InputFieldMargin3">
                    <p className="LabelGreyHeaderText InterExBoldTextFont" style={{color:"#2494D9"}} id="TotalPoinHeaderText">Total Poin:</p>
                    <p className="LabelGreyHeaderText InterBoldTextFont" style={{color:"#ED7C42",marginLeft:"auto"}} id="TotalPoinInfoText">-- <img src="/Assets/images/ButtonIcon/coin-icon.svg" /></p>
                  </div>
                  <div className="InputFieldMargin3">
                    <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#2494D9"}} id="MemberPoinHeaderText">Member Poin (MP):</p>
                    <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#ED7C42",marginLeft:"auto"}} id="MemberPoinInfoText">--</p>
                  </div>
                  <div className="InputFieldMargin2">
                    <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#2494D9"}} id="PingPoinHeaderText">Ping Poin (PP):</p>
                    <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#ED7C42",marginLeft:"auto"}} id="PingPoinInfoText">--</p>
                  </div>
                </div>
                <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop InputFieldContainerInvalid" id="TukarPointButton">
                  <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto"}} id="TukarPointButtonWrapper">
                    <img src="/Assets/images/ButtonIcon/check-circle-white.svg" className="BasicIconInsideButton2" style={{marginLeft:"0"}} />
                    <p id="TukarPointButtonText">Tukar Poin</p>
                  </div>
                </button>
              </div>
              <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius OriginalPriceToHideOnOff" style={{backgroundColor:"#F1F7FB"}}>
                <div className="InputFieldMargin3">
                  <p className="LabelGreyHeaderSmallerText2 InterMediumTextFont" style={{color:"#2494D9"}} id="HistoryPointHeaderText">History Poin</p>
                  <p className="LabelGreyHeaderSmallerText InterMediumTextFont HyperlinkUnderlineText" style={{color:"#2494D9",marginLeft:"auto",display:"none"}} id="ViewAllHyperlinkText">View All</p>
                </div>
                <div className="PriceTextMainContainer" id="HistoryContainerRefMenu">
                  <div className="PriceMainTextWrapper WhiteContainerPrice BasicRoundRadius">
                    <div className="Price1stWrapper" style={{width:"35%"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#101828"}}>-- --- ----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"0"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#667085"}}>--:--</p>
                      </div>
                    </div>
                    <div className="Price2ndWrapper" style={{width:"60%","overflow":"hidden",display:"flex",WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#000000",width:"100%",WebkitTextAlign:"end",textAlign:"end",WebkitTextOverflow:"ellipsis",textOverflow:"ellipsis","overflow":"hidden",whiteSpace:"nowrap"}}>----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"auto"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#626B79",marginTop:"auto",marginBottom:"auto"}}>-- ----- Poin<img src="/Assets/images/ButtonIcon/coin-icon.svg" style={{marginRight:"0"}} /></p>
                      </div>
                    </div>
                  </div>
                  <div className="PriceMainTextWrapper WhiteContainerPrice BasicRoundRadius" style={{"overflow":"hidden"}}>
                    <div className="Price1stWrapper" style={{width:"35%"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#101828"}}>-- --- ----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"0"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#667085"}}>--:--</p>
                      </div>
                    </div>
                    <div className="Price2ndWrapper" style={{width:"60%","overflow":"hidden",display:"flex", WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#000000",width:"100%",WebkitTextAlign:"end",textAlign:"end",WebkitTextOverflow:"ellipsis",textOverflow:"ellipsis","overflow":"hidden",whiteSpace:"nowrap"}}>----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"auto"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#626B79",marginTop:"auto",marginBottom:"auto"}}>-- ----- Poin<img src="/Assets/images/ButtonIcon/coin-icon.svg" style={{marginRight:"0"}} /></p>
                      </div>
                    </div>
                  </div>
                  <div className="PriceMainTextWrapper WhiteContainerPrice BasicRoundRadius">
                    <div className="Price1stWrapper" style={{width:"35%"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#101828"}}>-- --- ----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"0"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#667085"}}>--:--</p>
                      </div>
                    </div>
                    <div className="Price2ndWrapper" style={{width:"60%","overflow":"hidden",display:"flex",WebkitFlexDirection:"column", msFlexDirection:"column",flexDirection:"column"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#000000",width:"100%",WebkitTextAlign:"end",textAlign:"end",WebkitTextOverflow:"ellipsis",textOverflow:"ellipsis","overflow":"hidden",whiteSpace:"nowrap"}}>----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"auto"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#626B79",marginTop:"auto",marginBottom:"auto"}}>-- ----- Poin<img src="/Assets/images/ButtonIcon/coin-icon.svg" style={{marginRight:"0"}} /></p>
                      </div>
                    </div>
                  </div>
                  <div className="PriceMainTextWrapper WhiteContainerPrice BasicRoundRadius" style={{"overflow":"hidden"}}>
                    <div className="Price1stWrapper" style={{width:"35%"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#101828"}}>-- --- ----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"0"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#667085"}}>--:--</p>
                      </div>
                    </div>
                    <div className="Price2ndWrapper" style={{width:"60%","overflow":"hidden",display:"flex",WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{color:"#000000",width:"100%",WebkitTextAlign:"end",textAlign:"end",WebkitTextOverflow:"ellipsis",textOverflow:"ellipsis","overflow":"hidden",whiteSpace:"nowrap"}}>----</p>
                      <div className="PoinWithIconWrapper" style={{marginLeft:"auto"}}>
                        <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{color:"#626B79",marginTop:"auto",marginBottom:"auto"}}>-- ----- Poin<img src="/Assets/images/ButtonIcon/coin-icon.svg" style={{marginRight:"0"}} /></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ReferralRightWrapper">
              <div className="BasicTextButton BasicBoxShadow AllContentMarginPayment BasicRoundRadius OriginalPriceToHideOnOff" style={{backgroundColor:"#F1F7FB","padding":"0"}}>
                <div className="BasicTextButton BasicBoxShadow TopReferralSectionButtonContainer" style={{width:"auto"}}>
                  <div style={{WebkitFlex:"1",msFlex:"1",flex:"1",height:"fit-content",display:"flex",zIndex:"1"}}>
                    <button className="TopReferralSectionButton TopReferralSectionSelected Selectable2" id="AjakTemenSectionButton">
                      <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont" id="AjakTemenDoubleCuanButtonText">Ajak Temen Dobel Cuan</p>
                    </button>
                    <button className="TopReferralSectionButton Selectable2" id="NginepGratisSectionButton">
                      <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont">#NginepGratis</p>
                    </button>
                  </div>
                  <div className="SelectedSortOrangeWrapper" id="SelectedSortOrangeWrapper" style={{"left":"0%",width:"50%"}}>
                    <div className="SelectedSortOrange BasicRoundRadius" style={{width:"100%"}} />
                  </div>
                </div>
                <div className="ListOfRefPingMainContainer">
                  <div className="BlueTotalPingContainer BasicRoundRadius">
                    <div style={{WebkitFlex:"1",msFlex:"1",flex:"1",height:"fit-content",display:"flex"}}>
                      <p className="PaymentSectionHeaderText2" id="RefMenuHowManyText" style={{whiteSpace:"nowrap"}}>--</p>
                      <div className="BlueTopHeaderMessageRefMenuWrapper">
                        <p className="LabelGreyHeaderText InterBoldTextFont" id="RefMenuHeaderText">Ping Berhasil</p>
                        <p className="LabelGreyHeaderSmallerText InterRegularTextFont" id="RefMenuMessageText">Jumlah Ping Completed yang berhasil kamu undang lewat referral mu</p>
                      </div>
                    </div>
                    <div className="InputFieldAndShareButtonRef" id="ShareReferralInputContainer">
                      <p className="LabelGreyHeaderSmallerText2 InterRegularTextFont CopyText" id="CopyIdTextRefMenu">------------ <img src="/Assets/images/ButtonIcon/copy-grey.svg" className="Selectable2" /></p>
                      <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop InputFieldContainerInvalid" id="ShareButtonRefMenu">
                        <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto"}} className="WhichTargetAnim" id="ShareButtonWrapperRefMenu">
                          <img src="/Assets/images/ButtonIcon/share-white-icon.svg" className="BasicIconInsideButton2" style={{marginLeft:"0"}} />
                          <p className='HideOnMobile2' id="ShareReferralBtnText">Share Referral</p>
                          <p className='ShowOnMobile2' id="ShareReferralBtnShowDP2Text">Share</p>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="RefMenuWhitePanelContainer BasicRoundRadius">
                    <div className="BasicContenMarginWrapper">
                      <table className="ReffTableContainer" id="ReffTableContainer">
                        <tbody id="ReffTableTBody">
                          <tr>
                            <td style={{width:"25%"}}>
                              <div className="ReffTableTDWrapper">
                                <div className="UserTopProfileIcon">
                                  <div className="loading_grey" style={{width:"100%",height:"100%"}} />
                                </div>
                                <div className="RoomSmallInfo loading_grey" style={{"margin":"auto 0",width:"70%"}} />
                              </div>
                            </td>
                            <td style={{width:"25%"}}>
                              <div className="ReffTableTDWrapper">
                                <div className="RoomSmallInfo loading_grey" style={{"margin":"auto 0",width:"50%"}} />
                              </div>
                            </td>
                            <td style={{width:"50%"}}>
                              <div className="ReffTableTDWrapper">
                                <div className="RoomSmallInfo loading_grey" style={{"margin":"auto 0",width:"30%"}} />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="NoFeaturedPropertyFoundContainer" id="BelumAdaMenginapContainer" style={{display:"none"}}>
                        <img src="/Assets/images/Icon/belum-ada-menginap.svg" className="NoFoundIcon2" />
                        <p className="NoFoundHeaderText InterBoldTextFont" id="BelumAdaYangMenginapHeaderText">Belum Ada Teman Menginap</p>
                        <p className="NoFoundMessageText InterRegularTextFont" style={{width:"85%"}} id="BelumAdaYangMenginapMessageText">Ayo undang teman-temanmu untuk Ping (Booking) di PinginGo dan dapatkan voucher menginap! Semakin banyak teman yang menginap, semakin banyak juga voucher yang bisa kamu dapatkan.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ListOfRefPingMainContainer" id="PingHowToStepRefMenuContainer">
                  <div className="RoomHotelRightInfo2 loading_grey HideAfterStepSection" style={{marginLeft:"0",width:"40%"}} />
                  <p className="PaymentSectionHeaderText InterMediumTextFont ShowAfterStepSection InputFieldMargin2" style={{display:"none"}} id="CaraMudahNginepGratisText">Cara Mudah #NginepGratis</p>
                  <div className="CaraNginepStepWrapper">
                    <div className="CaraIconWrapper">
                      <div className="CaraIconContainer loading_grey RemoveClassAfrerStepSection" style={{backgroundColor:"#66B4E4"}}>
                        <img src="/Assets/images/Icon/loudspeaker.svg" className="ShowAfterStepSection" style={{display:"none"}} />
                      </div>
                      <div className="CaraDottedLine" />
                    </div>
                    <div className="CaraStepTextWrapper">
                      <p className="LabelGreyHeaderText InterBoldTextFont ShowAfterStepSection" id="ReferralStep1Header" style={{display:"none"}}>Bagikan Akomodasi Favoritmu</p>
                      <p className="LabelGreyHeaderSmallerText InterRegularTextFont ShowAfterStepSection" id="ReferralStep1Message" style={{display:"none"}}>Kasih tau kita hotel keren mana yang jadi favoritmu! Bagikan link hotel ke semua temanmu dan ajak mereka buat ping hotel itu bareng PinginGo</p>
                      <div className="RoomHotelRightInfo2 loading_grey HideAfterStepSection" style={{marginLeft:"0"}} />
                      <div className="RoomSmallInfo loading_grey HideAfterStepSection" />
                    </div>
                  </div>
                  <div className="CaraNginepStepWrapper">
                    <div className="CaraIconWrapper">
                      <div className="CaraIconContainer loading_grey RemoveClassAfrerStepSection" style={{backgroundColor:"#ED7C42"}}>
                        <p className="LabelGreyHeaderText InterMediumTextFont ShowAfterStepSection" style={{display:"none"}}>Ping!</p>
                      </div>
                      <div className="CaraDottedLine" />
                    </div>
                    <div className="CaraStepTextWrapper">
                      <p className="LabelGreyHeaderText InterBoldTextFont ShowAfterStepSection" id="ReferralStep2Header" style={{display:"none"}}>Make Ping!</p>
                      <p className="LabelGreyHeaderSmallerText InterRegularTextFont ShowAfterStepSection" id="ReferralStep2Message" style={{display:"none"}}>Pastikan teman mu melakukan Ping (booking) di hotel yang sudah kamu rekomendasikan</p>
                      <div className="RoomHotelRightInfo2 loading_grey HideAfterStepSection" style={{marginLeft:"0"}} />
                      <div className="RoomSmallInfo loading_grey HideAfterStepSection" />
                    </div>
                  </div>
                  <div className="CaraNginepStepWrapper">
                    <div className="CaraIconWrapper">
                      <div className="CaraIconContainer loading_grey RemoveClassAfrerStepSection" style={{backgroundColor:"#2494D9"}}>
                        <img src="/Assets/images/Icon/discount-voucher.svg" className="ShowAfterStepSection" style={{display:"none"}} />
                      </div>
                    </div>
                    <div className="CaraStepTextWrapper">
                      <p className="LabelGreyHeaderText InterBoldTextFont ShowAfterStepSection" id="ReferralStep3Header" style={{display:"none"}}>Dapatkat Voucher</p>
                      <p className="LabelGreyHeaderSmallerText InterRegularTextFont ShowAfterStepSection" id="ReferralStep3Message" style={{display:"none"}}>Setiap temanmu berhasil (Ping) Booking kamu akan mendapatkan poin yang bisa ditukarkan ke voucher menginap PinginGo</p>
                      <div className="RoomHotelRightInfo2 loading_grey HideAfterStepSection" style={{marginLeft:"0"}} />
                      <div className="RoomSmallInfo loading_grey HideAfterStepSection" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <RightPanelMobile/>

      <Footer/>
    </>
  )
}

export default Referral